module.exports = __webpack_public_path__ + "static/media/report_content.4930379d.svg";